export default __webpack_public_path__ + "static/media/physo-sec.63a2ba5d.png";